// Copyright (c) StrangeBee 2024

import { FooterProps } from '@Molecules/THFilter/components/Footer';
import { THFilter } from '@Molecules/THFilter/THFilter';
import { FilterFormatter } from '@Organisms/Filter/FilterPreview/FilterPreview';
import { useListAllUsers } from '@Queries/userQueries';
import React, { useMemo } from 'react';
import { ReactElement } from 'react';

export const Footer = ({ formatter, ...rest }: FooterProps): ReactElement => {
    const { data: currentUserList = [] } = useListAllUsers();

    const currentUsersListTreat: Record<string, string> = useMemo(
        () => currentUserList.reduce((g, { login, name }): Record<string, string> => ({ ...g, [login]: name }), {}),
        [currentUserList],
    );

    const formatterExtended: FilterFormatter = useMemo(
        () => ({
            ...formatter,
            user: ({ values = [] }): string => {
                values = Array.isArray(values) ? values : [values];
                return values
                    .reduce((g: string[], login): string[] => {
                        const name = currentUsersListTreat[login] || null;
                        return name !== null ? [...g, name] : g;
                    }, [])
                    .join(', ');
            },
        }),
        [currentUsersListTreat, formatter],
    );

    return <THFilter.Footer formatter={formatterExtended} {...rest} />;
};

Footer.displayName = 'Footer';
